var map = {
	"./helpImg/api_0.png": 6836,
	"./helpImg/api_0_v1.png": 8842,
	"./helpImg/api_1.png": 9341,
	"./helpImg/api_1_v1.png": 3881,
	"./helpImg/api_2_v1.png": 4144,
	"./helpImg/api_3_v1.png": 3663,
	"./helpImg/api_4_v1.png": 7950,
	"./helpImg/api_5_v1.png": 3997,
	"./helpImg/api_6_v1.png": 6276,
	"./helpImg/api_7_v1.png": 259,
	"./helpImg/api_8_v1.png": 7794,
	"./icon_pause.svg": 9758,
	"./icon_play.svg": 3598,
	"./icon_stop.svg": 7880,
	"./logo.png": 3153,
	"./logo_ada.svg": 7722,
	"./logo_bnb.svg": 1556,
	"./logo_btc.svg": 7443,
	"./logo_doge.svg": 9545,
	"./logo_eth.svg": 1631,
	"./logo_sol.svg": 6604,
	"./logo_xrp.svg": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;